document.addEventListener('DOMContentLoaded', function() {
  const VideoLoader = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
          const loadVideo = entry.target
          if (!loadVideo.src) {
            loadVideo.src = loadVideo.dataset.src;
            loadVideo.removeAttribute('data-src');
          }   
      }
    });
  }, { 
    rootMargin: "200px", // 预加载距离视口 400px 的视频
  })
  
  const videos = document.querySelectorAll('.yg-lazy-load-video');
  videos.forEach(video => VideoLoader.observe(video));

  class YGMegaMenuTab extends YGUtils {
    constructor() {
      super();
      this.init();
    }

    init() {
      const tabItems = this.querySelectorAll('.yg-menu-top-tab-item');
      const tabContents = this.querySelectorAll('.yg-menu-top-tab-content');

      if (tabItems.length === 0 || tabContents.length === 0) return;

      tabItems[0].classList.add('active');
      tabContents[0].classList.add('active');

      tabItems.forEach((tab, index) => {
        tab.addEventListener('mouseenter', () => {
          this.switchTab(index, tabItems, tabContents);
        });
      });
    }

    switchTab(index, tabItems, tabContents) {
      tabItems.forEach(tab => tab.classList.remove('active'));
      tabContents.forEach(content => content.classList.remove('active'));

      tabItems[index].classList.add('active');
      if (tabContents[index]) {
        tabContents[index].classList.add('active');
      }
    }
  }

  if (!window.customElements.get('yg-mega-menu-tab')) {
    window.customElements.define('yg-mega-menu-tab', YGMegaMenuTab);
  }

  class YGAccordion extends YGUtils {
    constructor() {
      super();
      this.init();
    }

    init() {
      const header = this.querySelector(".yg-accordion-header");
      const content = this.querySelector(".yg-accordion-content");
      const trueHeight = content.scrollHeight;
      content.style.setProperty("--true-height", `${trueHeight}px`);
      header.addEventListener("click", () => { 
        this.classList.toggle("yg-accordion-open");
      });
    }
  }

  if (!window.customElements.get("yg-accordion")) {
    window.customElements.define("yg-accordion", YGAccordion);
  }

  // YG Quantity Selector - 代理点击到 .product-info__quantity-selector
  class YGQuantitySelector extends YGUtils {
    constructor() {
      super();
      this.observer = null;
      this.currentDecreaseHandler = null;
      this.currentIncreaseHandler = null;
      this.isBound = false;
      this.init();
    }

    init() {
      // 设置 MutationObserver 来监视 DOM 变化
      this.setupObserver();

      // 尝试初始绑定
      this.tryBind();
    }

    setupObserver() {
      this.observer = new MutationObserver((mutations) => {
        let shouldCheckRebind = false;

        for (const mutation of mutations) {
          if (mutation.type === 'childList') {
            // 检查是否有 .product-info__quantity-selector 相关的变化
            const checkForQuantitySelector = (nodes) => {
              for (const node of nodes) {
                if (node.nodeType === Node.ELEMENT_NODE) {
                  if (node.classList && node.classList.contains('product-info__quantity-selector')) {
                    return true;
                  }
                  if (node.querySelector && node.querySelector('.product-info__quantity-selector')) {
                    return true;
                  }
                  // 递归检查子节点
                  if (node.children && checkForQuantitySelector(node.children)) {
                    return true;
                  }
                }
              }
              return false;
            };

            if (checkForQuantitySelector(mutation.addedNodes) || checkForQuantitySelector(mutation.removedNodes)) {
              shouldCheckRebind = true;
              break;
            }
          }
        }

        if (shouldCheckRebind) {
          // 延迟执行以确保 DOM 完全更新
          setTimeout(() => {
            this.tryBind();
          }, 10);
        }
      });

      // 开始观察整个文档的变化
      this.observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    }

    tryBind() {
      const originalSelector = document.querySelector('.product-info__quantity-selector');

      if (originalSelector && !this.isBound) {
        // 发现新的 quantity selector，进行绑定
        this.bindToSelector(originalSelector);
      } else if (!originalSelector && this.isBound) {
        // quantity selector 被移除，解绑
        this.unbind();
      } else if (originalSelector && this.isBound) {
        // 检查是否是同一个元素，如果不是则重新绑定
        const currentOriginalInput = originalSelector.querySelector('.quantity-selector__input');
        if (currentOriginalInput !== this.boundOriginalInput) {
          this.unbind();
          this.bindToSelector(originalSelector);
        }
      }
    }

    bindToSelector(originalSelector) {
      // 先解绑之前的绑定
      this.unbind();

      // 获取原始选择器中的所有按钮
      const originalButtons = originalSelector.querySelectorAll('.quantity-selector__button');
      if (originalButtons.length < 2) return;

      // 通常第一个按钮是减号，第二个按钮是加号
      const originalDecreaseBtn = originalButtons[0];
      const originalIncreaseBtn = originalButtons[1];

      // 获取原始选择器中的输入框
      this.boundOriginalInput = originalSelector.querySelector('.quantity-selector__input');

      // 获取当前元素中的所有按钮
      const currentButtons = this.querySelectorAll('.quantity-selector__button');
      if (currentButtons.length < 2) return;

      // 通常第一个按钮是减号，第二个按钮是加号
      const decreaseBtn = currentButtons[0];
      const increaseBtn = currentButtons[1];

      // 获取当前元素中的输入框
      const currentInput = this.querySelector('.quantity-selector__input');

      // 创建事件处理器
      this.currentDecreaseHandler = (e) => {
        e.preventDefault();
        if (originalDecreaseBtn) {
          originalDecreaseBtn.click();
        }
      };

      this.currentIncreaseHandler = (e) => {
        e.preventDefault();
        if (originalIncreaseBtn) {
          originalIncreaseBtn.click();
        }
      };

      // 为减号按钮添加事件监听器
      if (decreaseBtn && originalDecreaseBtn) {
        decreaseBtn.addEventListener('click', this.currentDecreaseHandler);
      }

      // 为加号按钮添加事件监听器
      if (increaseBtn && originalIncreaseBtn) {
        increaseBtn.addEventListener('click', this.currentIncreaseHandler);
      }

      // 同步一次数字值
      if (currentInput && this.boundOriginalInput) {
        currentInput.value = this.boundOriginalInput.value;
      }

      this.isBound = true;
    }

    unbind() {
      if (!this.isBound) return;

      // 获取当前元素中的按钮
      const currentButtons = this.querySelectorAll('.quantity-selector__button');
      if (currentButtons.length >= 2) {
        const decreaseBtn = currentButtons[0];
        const increaseBtn = currentButtons[1];

        // 移除事件监听器
        if (decreaseBtn && this.currentDecreaseHandler) {
          decreaseBtn.removeEventListener('click', this.currentDecreaseHandler);
        }
        if (increaseBtn && this.currentIncreaseHandler) {
          increaseBtn.removeEventListener('click', this.currentIncreaseHandler);
        }
      }

      // 清除引用
      this.currentDecreaseHandler = null;
      this.currentIncreaseHandler = null;
      this.boundOriginalInput = null;
      this.isBound = false;
    }

    disconnectedCallback() {
      this.unbind();
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    }
  }

  if (!window.customElements.get('yg-quantity-selector')) {
    window.customElements.define('yg-quantity-selector', YGQuantitySelector);
  }

  class YGBuyItNow extends YGUtils {
    constructor() {
      super()
      this.init()
    }
    init() {
      // 这里放置初始化逻辑
      let _this = this
      let $button = _this.querySelector('.yg-buy-button')
      $button.addEventListener('click', (e) => {
        _this.buttonClick()
      })
    }
    buttonClick() {
      let buyBtn = this.querySelector('.shopify-payment-button .shopify-payment-button__more-options') || this.querySelector('.shopify-payment-button .shopify-payment-button__button');
      console.log(buyBtn);
      buyBtn.click();
    }
  }
  if (!window.customElements.get('yg-buy-it-now')) {
    window.customElements.define('yg-buy-it-now', YGBuyItNow)
  }

  class YGMegaMenu extends YGUtils {
    constructor() {
      super();
      this.tabs = null;
      this.items = null;
      this.tabHandlers = [];
      this.handleResize = this.handleResize.bind(this);
      this.init();
    }
    init() {
      this.tabs = this.querySelectorAll('.yg-collection-tab-item');
      this.items = this.querySelectorAll('.yg-collection-product-item');
      this.titles = this.querySelectorAll('.yg-collection-products-title')
      if (this.tabs.length === 0 || this.items.length === 0) return;

      // 初始化高亮和展示
      this.tabs.forEach((tab, i) => {
        tab.classList.toggle('active', i === 0);
        if (this.items[i]) this.items[i].classList.toggle('active', i === 0);
      });

      // 根据屏幕宽度设置事件
      this.handleResize();
      window.addEventListener('resize', this.handleResize);
    }

    switchTab(index) {
      this.tabs.forEach((t, j) => t.classList.toggle('active', index === j));
      this.items.forEach((p, j) => p.classList.toggle('active', index === j));
      this.titles.forEach((title, j) => title.classList.toggle('active', index === j));
    }

    handleResize() {
      const isMobile = window.innerWidth < 1150;

      // 清除现有事件监听器
      this.tabHandlers.forEach(({ tab, handler, type }) => {
        tab.removeEventListener(type, handler);
      });
      this.tabHandlers = [];

      // 根据设备类型添加事件
      this.tabs.forEach((tab, i) => {
        let handler;
        let type;

        if (isMobile) {
          // 移动端：点击切换
          type = 'click';
          handler = () => this.switchTab(i);
        } else {
          // 桌面端：悬浮切换
          type = 'mouseenter';
          handler = () => this.switchTab(i);
        }

        tab.addEventListener(type, handler);
        this.tabHandlers.push({ tab, handler, type });
      });
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.handleResize);
      // 清除所有事件监听器
      this.tabHandlers.forEach(({ tab, handler, type }) => {
        tab.removeEventListener(type, handler);
      });
    }
  }
  if (!window.customElements.get('yg-mega-menu')) {
    window.customElements.define('yg-mega-menu', YGMegaMenu);
  }

  class YGCollectionProducts extends YGUtils {
    constructor() {
      super();
      this.initSwiper();
    }

    initSwiper() {
      new Swiper(this, {
        slidesPerView: 3,
        spaceBetween: 8,

      })
    }
  }

  if (!window.customElements.get('yg-collection-products')) {
    window.customElements.define('yg-collection-products', YGCollectionProducts);
  }

  class YGMegaMenuSwiper extends YGUtils {
    constructor() {
      super();
      this.initSwiper();
    }

    initSwiper() {
      const nextButton = this.querySelector('.swiper-button-next');
      const prevButton = this.querySelector('.swiper-button-prev');
      new Swiper(this, {
        slidesPerView: 4,
        spaceBetween: 12,
        navigation: {
          nextEl: nextButton,
          prevEl: prevButton,
        },
        breakpoints: {
          1200: {
            slidesPerView: 5,
            spaceBetween: 12,
          },
          1400: {
            slidesPerView: 6,
            spaceBetween: 12,
          }
        },

      })
    }
  }

  if (!window.customElements.get('yg-mega-menu-swiper')) {
    window.customElements.define('yg-mega-menu-swiper', YGMegaMenuSwiper);
  }
})
